import { memoize as memoizeFn } from "lodash-es";

export const memoize =
	(resolver?: () => any) => (_target: object, _propertyKey: string, descriptor: PropertyDescriptor) => {
		const originalMethod = descriptor.value;
		descriptor.value = memoizeFn(originalMethod, resolver);
		return descriptor;
	};
